import React from "react";
import PathOption from "../PathOption";
import PathOptionGroup from "../PathOptionGroup";

function PathBuilderOptionsWalletConnection({
  t,
  options,
  handleOptionChange,
  osSelected,
  blueWalletExpanded,
  setBlueWalletExpanded,
  bullWalletExpanded,
  setBullWalletExpanded,
  sparrowWalletExpanded,
  setSparrowWalletExpanded,
}) {
  return (
    <PathOptionGroup title={t("pathBuilder.categories.walletConnection")}>
      <div className="path-option-subgroup">
        <h4
          className="path-option-subgroup-title"
          style={{ cursor: "pointer", userSelect: "none" }}
          onClick={() => setBlueWalletExpanded(!blueWalletExpanded)}
        >
          {blueWalletExpanded ? "▼" : "▶"} {t("pathBuilder.categories.bluewallet")}
        </h4>
        {blueWalletExpanded && (
          <div className="path-option-subgroup-options">
            <PathOption
              id="download-bluewallet"
              label={t("pathBuilder.checkboxes.downloadBlueWallet")}
              checked={options.downloadBlueWallet}
              onChange={() => handleOptionChange("downloadBlueWallet")}
              disabled={!osSelected}
            />
            <PathOption
              id="configure-seedsigner-for-bluewallet"
              label={t("pathBuilder.checkboxes.configureSeedSignerForBlueWallet")}
              checked={options.configureSeedSignerForBlueWallet}
              onChange={() => handleOptionChange("configureSeedSignerForBlueWallet")}
              disabled={!osSelected}
            />
            <PathOption
              id="export-xpub-to-bluewallet"
              label={t("pathBuilder.checkboxes.exportXpubToBlueWallet")}
              checked={options.exportXpubToBlueWallet}
              onChange={() => handleOptionChange("exportXpubToBlueWallet")}
              disabled={!osSelected}
            />
            <PathOption
              id="import-wallet-into-bluewallet"
              label={t("pathBuilder.checkboxes.importWalletIntoBlueWallet")}
              checked={options.importWalletIntoBlueWallet}
              onChange={() => handleOptionChange("importWalletIntoBlueWallet")}
              disabled={!osSelected}
            />
            <PathOption
              id="receive-bitcoin-in-bluewallet"
              label={t("pathBuilder.checkboxes.receiveBitcoinInBlueWallet")}
              checked={options.receiveBitcoinInBlueWallet}
              onChange={() => handleOptionChange("receiveBitcoinInBlueWallet")}
              disabled={!osSelected}
            />
            <PathOption
              id="create-transaction"
              label={t("pathBuilder.checkboxes.createTransaction")}
              checked={options.createTransaction}
              onChange={() => handleOptionChange("createTransaction")}
              disabled={!osSelected}
            />
            <PathOption
              id="broadcast-transaction"
              label={t("pathBuilder.checkboxes.broadcastTransaction")}
              checked={options.broadcastTransaction}
              onChange={() => handleOptionChange("broadcastTransaction")}
              disabled={!osSelected}
            />
            <PathOption
              id="verify-transaction"
              label={t("pathBuilder.checkboxes.verifyTransaction")}
              checked={options.verifyTransaction}
              onChange={() => handleOptionChange("verifyTransaction")}
              disabled={!osSelected}
            />
          </div>
        )}
      </div>

      <div className="path-option-subgroup">
        <h4
          className="path-option-subgroup-title"
          style={{ cursor: "pointer", userSelect: "none" }}
          onClick={() => setBullWalletExpanded(!bullWalletExpanded)}
        >
          {bullWalletExpanded ? "▼" : "▶"} {t("pathBuilder.categories.bullWallet")}
        </h4>
        {bullWalletExpanded && (
          <div className="path-option-subgroup-options">
            <PathOption
              id="download-bull-wallet"
              label={t("pathBuilder.checkboxes.downloadBullWallet")}
              checked={options.downloadBullWallet}
              onChange={() => handleOptionChange("downloadBullWallet")}
              disabled={!osSelected}
            />
          </div>
        )}
      </div>

      <div className="path-option-subgroup">
        <h4
          className="path-option-subgroup-title"
          style={{ cursor: "pointer", userSelect: "none" }}
          onClick={() => setSparrowWalletExpanded(!sparrowWalletExpanded)}
        >
          {sparrowWalletExpanded ? "▼" : "▶"} {t("pathBuilder.categories.sparrowWallet")}
        </h4>
        {sparrowWalletExpanded && (
          <div className="path-option-subgroup-options">
            <PathOption
              id="download-sparrow-wallet"
              label={t("pathBuilder.checkboxes.downloadSparrowWallet")}
              checked={options.downloadSparrowWallet}
              onChange={() => handleOptionChange("downloadSparrowWallet")}
              disabled={!osSelected}
            />
          </div>
        )}
      </div>
    </PathOptionGroup>
  );
}

export default PathBuilderOptionsWalletConnection;
